import { MdFileDownload } from "react-icons/md";
import { QuotationMotivationAbilities } from "../../../../i18n/translatedMessages";

const MotivationsAbilitiesQuotation = ({ quotationButton, pdfDownload }) => {
  return (
    <>
      <div className="">
        <div className="text-center mb-5">
          <img
            className=""
            src="https://assets.mydna.company/logo-myco-background-faded.png"
            style={{ maxWidth: "170px" }}
          />
        </div>
        <p className="text-center mb-5">
          <strong>{QuotationMotivationAbilities.quoationMotivationsAbilitiesText}</strong>
        </p>
        <div className="d-flex align-items-center justify-content-center">
          <div className="me-4">
            <div className="button">
              <button
                className="btn rounded-pill"
                style={{
                  backgroundColor: "#7A6BE8",
                  color: "white",
                  width: "200px",
                }}
                onClick={quotationButton}
              >
                {QuotationMotivationAbilities.getQuotation}
              </button>
            </div>
          </div>
          <div>
            <a href={pdfDownload} target="_blank" rel="noopener noreferrer">
              <button
                className="btn rounded-pill"
                style={{
                  backgroundColor: "#27E6C4",
                  color: "white",
                  width: "200px",
                }}
              >
                {QuotationMotivationAbilities.downloadModel}
                <MdFileDownload className="ms-2" />
              </button>
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default MotivationsAbilitiesQuotation;
